module.exports = __webpack_public_path__ + "img/2w.b5eb5c50.svg";